import request from '@/utils/request'

export function changeAttribute(data) {
    return request({
        url: '/backend/employee/changeAttribute',
        method: 'post',
        data: data
    })
}

export function searchUser(data) {
    return request({
        url: '/backend/employee/searchUser',
        method: 'post',
        data: data
    })
}

export function orderList(data) {
    return request({
        url: '/backend/employee/getOrderList',
        method: 'post',
        data: data
    })
}

export function employeeListV2(data) {
    return request({
        url: '/backend/employee/getEmployeeListV2',
        method: 'post',
        data: data
    })
}

export function changeEmployee(data) {
    return request({
        url: '/backend/employee/changeEmployee',
        method: 'post',
        data: data
    })
}

export function createUpdate(data) {
    return request({
        url: '/backend/employee/createUpdate',
        method: 'post',
        data: data
    })
}